import React from 'react';
import Panel from '../../components/ui/Panel';
import { colors } from '../../theme/tokens';

function kebab(name: string): string {
  return name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

const tailwind = Object.entries(colors)
  .map(([name, value]) => `        'osrs-${kebab(name)}': '${value}',`)
  .join('\n');

const cssVars = Object.entries(colors)
  .map(([name, value]) => `  --osrs-${kebab(name)}: ${value};`)
  .join('\n');

const scssVars = Object.entries(colors)
  .map(([name, value]) => `$osrs-${kebab(name)}: ${value};`)
  .join('\n');

const typeLines = Object.entries(colors)
  .map(([name, value]) => `  ${name}: '${value}';`)
  .join('\n');

const ColorsImplementation: React.FC = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-3xl text-osrs-gold font-bold uppercase mb-4">Colors Implementation</h1>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Tailwind Configuration</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">
            These lines are generated from the token module, which is the same object the components use.
          </p>
          <pre className="bg-osrs-black p-4 font-mono text-sm text-osrs-yellow overflow-x-auto">{`// tailwind.config.js
module.exports = {
  theme: {
    extend: {
      colors: {
${tailwind}
      }
    }
  }
}`}</pre>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">CSS Variables</h2>
        <Panel>
          <pre className="bg-osrs-black p-4 font-mono text-sm text-osrs-yellow overflow-x-auto">{`:root {
${cssVars}
}`}</pre>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">SCSS Variables</h2>
        <Panel>
          <pre className="bg-osrs-black p-4 font-mono text-sm text-osrs-yellow overflow-x-auto">{scssVars}</pre>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">TypeScript</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">
            Import colors from the package instead of redeclaring the hex values.
          </p>
          <pre className="bg-osrs-black p-4 font-mono text-sm text-osrs-yellow overflow-x-auto">{`import { colors } from 'osrs-design-system';

type OSRSColors = {
${typeLines}
};`}</pre>
        </Panel>
      </section>
    </div>
  );
};

export default ColorsImplementation;
